import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { init as initData, getSupportedLngs } from './services/dataService';
import { initI18n } from './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

async function bootstrap() {
  await initData();
  await initI18n(getSupportedLngs());
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <React.Suspense fallback={null}>
        <App />
      </React.Suspense>
    </React.StrictMode>
  );
}

bootstrap();
reportWebVitals();

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('sw-update', { detail: registration }));
  },
  onSuccess: () => {
    console.log('[PWA] App cached for offline use.');
  },
});
